'use client'
import { type FC } from 'react'
import { HelpCenter } from './HelpCenter'
import { useFwfToggles } from '@/tools/fwf-toggles/client'

// Can remove this wrapper when toggle deleted https://glovoapp.atlassian.net/browse/WEBX-714
export const HelpCenterWrapper: FC = () => {
  const { toggles } = useFwfToggles()
  const isHelpCenterRendered =
    toggles['webx_react_dh_help_center_enabled'] && toggles['customer_help_center_enabled']

  return <>{isHelpCenterRendered && <HelpCenter />}</>
}
